import { useState, type FormEvent } from "react";
import { api, errorText } from "../api/client";
import { login } from "../session";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
      const returnUrl = new URLSearchParams(window.location.search).get("returnUrl");
      window.location.assign(returnUrl && returnUrl.startsWith("/") && !returnUrl.startsWith("//") ? returnUrl : "/today");
    } catch (err) {
      setError(errorText(err));
      setBusy(false);
    }
  };

  return (
    <main className="login">
      <h1>Familienplaner</h1>
      <form onSubmit={submit} className="card">
        <label>
          Name oder E-Mail
          <input type="text" autoComplete="username" autoCapitalize="none" autoCorrect="off" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label>
          Passwort
          <input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {error && <p className="error">{error}</p>}
        <button className="btn primary" disabled={busy}>{busy ? "Anmelden …" : "Anmelden"}</button>
      </form>
      <p className="muted small">Wanddisplay? <a href="/display">Hier koppeln</a>.</p>
      <DevicePairing />
    </main>
  );
}

/** Sprachterminal (Wandtablet) oder Display per Kopplungscode aus den Einstellungen anmelden. */
function DevicePairing() {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      const r = await api<{ kind: string }>("/api/v1/devices/pair", { body: { code } });
      window.location.assign(r.kind === "voice_terminal" ? "/calendar" : "/display");
    } catch (err) {
      setError(errorText(err));
    }
  };
  if (!open) return <p className="muted small">Tablet/Sprachterminal? <button type="button" className="btn ghost" onClick={() => setOpen(true)}>Mit Kopplungscode anmelden</button></p>;
  return (
    <form className="card" onSubmit={submit}>
      <label>Kopplungscode<input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="ABCD-EFGH" maxLength={12} autoFocus /></label>
      {error && <p className="error">{error}</p>}
      <button className="btn primary">Koppeln</button>
    </form>
  );
}
